import { AxiosResponse } from "axios";
import AuthUser from "../models/auth-user.entity";
import UserSession from "../models/session/user-session.entity";
import http from "./http.service";
import storageService from "./storage.service";

class AuthService {
  public saveAuth = (user: AuthUser): void => {
    storageService.setObject('token', btoa(JSON.stringify(user.formatAuthPayload())));
  };

  public getAuth = (): AuthUser => {
    const base64Auth = storageService.getObject('token');
    let user: AuthUser = new AuthUser();
    if (base64Auth) {
      const authStr = atob(base64Auth);
      user= new AuthUser(JSON.parse(authStr));
    }

    return user;
  };

  // Login só está completo após o retorno de /auth/user-info (que grava 'company').
  public isLoginComplete = (): boolean => {
    const session = new UserSession(storageService.getObject('session') || {});
    return !!session.accessToken && !!storageService.getObject('company');
  }

  public getAuthUserInfo = (token: string) => {
    return http.get('/auth/user-info')
      .then(({ data }: AxiosResponse) => data.data);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AuthService();
